import { AlertGateway } from './alert-gateway.interface';

export const initAlertAPI = (apiSlice: any, gateway: AlertGateway) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['Alert'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        getAllAlerts: builder.query({
          query: gateway.getAllAlerts,
          providesTags: ['Alert'],
        }),
        patchAlertAsSeen: builder.mutation({
          query: gateway.patchAlertAsSeen,
          invalidatesTags: ['Alert'],
        }),
      }),
      overrideExisting: false,
    });
};

export interface AlertSliceType {
  useGetAllAlertsQuery: Function;
  useLazyGetAllAlertsQuery: Function;
  usePatchAlertAsSeenMutation: Function;
}
